// Single source of truth for the public contact mailbox + a helper that opens a
// pre-filled support email in Gmail's WEB compose. We use Gmail's compose URL
// (not a `mailto:` link) so the click opens an email in the browser itself
// rather than launching a desktop mail client the visitor may not have set up.
export const SUPPORT_EMAIL = "contact@jaaga.ai";

const DEFAULT_SUBJECT = "Support Request, JaaGa";
const DEFAULT_BODY = [
  "Hi JaaGa Team,",
  "",
  "I'd like to get in touch with your support team regarding:",
  "",
  "[ Please describe your query here ]",
  "",
  "Thank you,",
].join("\n");

/**
 * Build a Gmail compose URL pointed at the support inbox with the subject and
 * body pre-filled. Open it in a new tab (target="_blank") so the visitor keeps
 * the JaaGa page they were on.
 */
export function supportMailUrl({
  subject = DEFAULT_SUBJECT,
  body = DEFAULT_BODY,
} = {}) {
  return (
    "https://mail.google.com/mail/?view=cm&fs=1" +
    `&to=${encodeURIComponent(SUPPORT_EMAIL)}` +
    `&su=${encodeURIComponent(subject)}` +
    `&body=${encodeURIComponent(body)}`
  );
}
